<!DOCTYPE html>
<!--<form name="probenliste">-->
<div id="hotContainer">
<!--  <hot-table ></hot-table>-->
<!--  <pre> {{tableSettings | json}}</pre>-->
  <hot-table
    [hotId]="probenlisteTabelleId"
    [settings]="tableSettings">
  </hot-table>
<!--  <button (click)="swapHotData()" class="controls">getData</button>-->
</div>
<!--<div id="hotButtonContainer">-->
<!--  <button mat-raised-button (click)="zeileHinzufuegen()">Neue Zeile</button>-->
<!--  <button mat-raised-button (click)="letzteZeileLoeschen()">Zeile löschen</button>-->
<!--</div>-->
<!--</form>-->
